const block = document.querySelector('.tabs-block');

if (block) {
  window.addEventListener('DOMContentLoaded', () => {
    let tabs = document.querySelectorAll('.tabs-block__tab');
    const tabList = document.querySelector('[role="tablist"]');
    let content = document.querySelectorAll('.tabs-block__tabpanel');
    let prev = document.querySelector('.prev');
    let next = document.querySelector('.next');
    let activeTab = 0;
    let firstTab = function (tabs) { tabs.classList.add('active') };
    let firstContent = function (content) { content.classList.add('active') };
  
    firstTab(tabs[0]);
    firstContent(content[0]);

    let focusedTab = 0;

    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', () => tabClick(i));
      tabs[i].tabIndex = -1;
      tabs[i].setAttribute('aria-selected', 'false');
    }

    tabs[0].tabIndex = 0;
    tabs[0].setAttribute('aria-selected', 'true');
  
    prev.addEventListener("click", (i) => {
      if (activeTab === 0) {
        activeTab = tabs.length - 1;
        tabClick(activeTab);
      } else {
        tabClick(activeTab - 1);
      }
    });
    
    next.addEventListener("click", (i) => {
      if (activeTab >= tabs.length - 1) {
        activeTab = 0;
        tabClick(activeTab);
      } else {
        tabClick(activeTab + 1);
      }
    });
  
    tabList.addEventListener("keydown", handleTabListKeydown);

    function updateTabFocus() {
      // Give each tab an index of -1 so that it cannot be focused by normal means (e.g. with the 'tab' key).
      for (const tab of tabs) {
        tab.setAttribute("tabindex", -1);
      }
      // Give only the currently focused tab an index of 0 so that it can be navigated to with the 'tab' key, and from there its siblings can be focused with the arrow keys.
      tabs[focusedTab].setAttribute("tabindex", 0);
      tabs[focusedTab].focus();
    }

    function handleTabListKeydown(event) {
      const key = event.key;

      if (key === "ArrowRight" || key === "ArrowLeft") {
        if (key === "ArrowRight") {
          focusedTab++;
          // We have gone past the end, wrap around to the start
          if (focusedTab >= tabs.length) {
            focusedTab = 0;
          }
        } else if (key === "ArrowLeft") {
          focusedTab--;
          // We have gone before the start, wrap around to the end
          if (focusedTab < 0) {
            focusedTab = tabs.length - 1;
          }
        }

        updateTabFocus();
      }
    }
  
    function tabClick(currentTab) {
      removeActive();
      //Add Active Class
      tabs[currentTab].classList.add('active');
      tabs[currentTab].setAttribute('aria-selected', 'true');
      tabs[currentTab].removeAttribute('tabindex');
      content[currentTab].classList.add('active');
      content[currentTab].focus();
      activeTab = currentTab;
    }
  
    function removeActive() {
      for (let i = 0; i < tabs.length; i++) {
        //Remove Active Class
        content[i].classList.remove('active');
        tabs[i].classList.remove('active');
        tabs[i].setAttribute('aria-selected', 'false');
        tabs[i].tabIndex = -1;
      }
    }
  });
}